import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

import { CenteredContainer } from './Spin.style';

interface Props {
  className?: string;
  size?: number;
  containerHeight?: string;
}

export function Spinner({ className = 'spinner', size = 2, containerHeight }: Props) {
  return (
    <CenteredContainer data-testid="spinner" className={className} $minHeight={containerHeight}>
      <Spin
        indicator={
          <LoadingOutlined
            spin={true}
            style={{
              color: `${({ theme }: { theme: any }) => theme.teal}`,
              fontSize: `${size}rem`,
            }}
          />
        }
      />
    </CenteredContainer>
  );
}
